import { render, staticRenderFns } from "./userProtection.vue?vue&type=template&id=1c6f7f9e&scoped=true&"
import script from "./userProtection.vue?vue&type=script&lang=js&"
export * from "./userProtection.vue?vue&type=script&lang=js&"
import style0 from "./userProtection.vue?vue&type=style&index=0&id=1c6f7f9e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6f7f9e",
  null
  
)

export default component.exports